var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('router-view'),_c('PoweredByFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }